module.exports = __webpack_public_path__ + "img/logo-footer-es.e14ed99a.webp";